import { Headline } from '@components/card-medium/card-medium.styles'
import InfoAndImageCard from '@components/info-and-image-card/index'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Container from '@material-ui/core/Container'
import MenuItem from '@material-ui/core/MenuItem'
import { useTheme } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { RenderRichText } from '@components/renderers'
import useStyles from './card-selector.styles'

const CardSelector = (props) => {
  const {
    headline,
    subtitle,
    categories,
    cardCollection,
    overText,
    tabsCollection,
    eyebrow,
    heading,
    summary,
    headingAlignment,
  } = props
  const _categories = categories || tabsCollection?.items?.map(item => item.heading) || []
  const _cardCollection = cardCollection || tabsCollection || { items: [] }
  const _overText = overText || eyebrow
  const _headline = headline || heading

  const firstCategory = _categories[0]

  const firstCard = _cardCollection?.items?.find((cardObj) => {
    return cardObj.series === firstCategory || cardObj.heading === firstCategory
  })

  const isMobile = useMediaQuery(useTheme().breakpoints.down('sm'))
  const [selectedCategory, setSelectedCategory] = useState(firstCategory)
  const [selectedCard, setSelectedCard] = useState(firstCard)
  const styles = useStyles({ headingAlignment })

  const Summary = () => (
    <>
      {summary ? (
        <div className={styles.subtitle}>
          <RenderRichText {...summary} />
        </div>
      ) : (
        <Typography className={styles.subtitle} variant="body1">
          {subtitle}
        </Typography>
      )}
    </>
  )

  const handleCategoryClick = (clickedCategory) => {
    setSelectedCategory(clickedCategory)
    const filteredCard = _cardCollection?.items?.find((cardObj) => {
      return cardObj.series === clickedCategory || cardObj.heading === clickedCategory
    })
    setSelectedCard(filteredCard)
  }

  return (
    <Container className={styles.root} data-testid="card-selector-container">
      {_overText && <Headline className={styles.overText} variant="overline">{_overText}</Headline>}
      <Typography className={styles.headline} variant="h3">{_headline}</Typography>
      <Summary />
      {_categories?.length > 0 && (
        <>
          {isMobile && (
            <div className={styles.locationInput}>
              <TextField
                id="card-category-select"
                type="text"
                name="card category"
                label="Select Category"
                select
                value={selectedCategory}
                onChange={e => handleCategoryClick(e.target.value)}
                className={styles.input}
                SelectProps={{
                  displayEmpty: true,
                  inputProps: { 'data-testid': 'card-category-input' },
                  IconComponent: () => (
                    <KeyboardArrowDownIcon
                      className={styles.selectArrow}
                      onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        e.currentTarget.parentNode.firstChild.click()
                      }}
                    />
                  ),
                  MenuProps: {
                    anchorOrigin: {
                      vertical: 'bottom',
                      horizontal: 'left',
                    },
                    getContentAnchorEl: null,
                    classes: { paper: styles.selectPaper },
                  },
                }}
              >
                {_categories.map((el) => {
                  return (
                    <MenuItem key={el} value={el} className={styles.menuItem} aria-label={`Display content, ${el}`}>{el}</MenuItem>
                  )
                })}
              </TextField>
            </div>
          )}
          <Box
            className={styles.categoryTagsRow}
            role="tablist"
            aria-label={`${headline} category tabs`}
          >
            {!isMobile && _categories.map(item => (
              <Button
                onClick={() => handleCategoryClick(item)}
                key={item}
                role="tab"
                className={`${styles.categoryTags} ${item === selectedCategory ? styles.active : ''}`}
                aria-selected={item === selectedCategory}
              >{item}
              </Button>
            ))}
          </Box>
          <Box className={styles.divider} />
        </>
      )}
      {selectedCard ? (
        <div className={styles.cardContainer}>
          <InfoAndImageCard
            heading={selectedCard.title || selectedCard.heading}
            subheading={selectedCard.summaryLong}
            richSummary={selectedCard.summary}
            cardImage={selectedCard.image}
            ctaText={selectedCard.ctaText || selectedCard.primaryCtaText}
            ctaLink={selectedCard.externalLink || selectedCard.primaryCtaUrl || selectedCard.primaryCtaLink}
            key={selectedCard.title || selectedCard.heading}
            largeCardVariant
          />
        </div>
      ) : (
        <div
          data-testid="no-results-page"
          className={styles.noResultsContainer}
        >
          <Typography variant="h5" className={styles.noResultsTitle}>
            No results in this category.
          </Typography>
          <Typography variant="body1" className={styles.noResultsBody}>
            Please select a different option.
          </Typography>
        </div>
      )}
    </Container>
  )
}

CardSelector.propTypes = {
  headline: PropTypes.string,
  subtitle: PropTypes.string,
  categories: PropTypes.array,
  cardCollection: PropTypes.object,
  overText: PropTypes.string,
  tabsCollection: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.shape({}))
  }),
  eyebrow: PropTypes.string,
  heading: PropTypes.string,
  summary: PropTypes.object,
  headingAlignment: PropTypes.oneOf(['Left', 'Center']),
}

export default CardSelector
